import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'user-module',
    loadChildren: () => import('./user/user.module').then(m => m.UserModule)
  },
  {
    path: 'permission-groups-module',
    loadChildren: () => import('./permission-groups/permission-groups.module').then(m => m.PermissionGroupsModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CommonRoutingModule { }
